import React from "react";
import "./Home.css";
import "./About.css";
import Footer from "./Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

function About() {
	const navigate = useNavigate();
	return (
		<div className="main-container">
			<div className="video-background">
				<img src="/images/about-main.jpeg" alt="bridge" />
			</div>

			<section className="hero-section hero-section-services" id="home">
				<h1>
					What does getting <span>Kinected</span> mean?
				</h1>
				<p className="hero-text">
					Working with Sibling Kinect allows for in depth conversations about
					the sibling experience and how to strengthen relationships within the
					family
				</p>
				<button className="cta-button" onClick={() => navigate("/contact")}>
					Contact Us
					<FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: "10px" }} />
				</button>
			</section>

			<section>
				<div className="mission-vision-container">
					<img src="/images/about-p2.jpeg" alt="siblings by window" />
					<div className="mission-vision-content">
						<div className="statement-block">
							<h2>Mission</h2>
							<p>
								Providing understanding, guidance, and encouragement to siblings
								navigating challenges while fostering a stronger family
								connection
							</p>
						</div>

						<div className="statement-block">
							<h2>Vision</h2>
							<p>Empowering siblings and strengthening the family unit</p>
						</div>
					</div>
				</div>
			</section>

			<section className="meet-profile-section">
				<div className="meet-container">
					<h2 className="meet-heading">Meet</h2>
					<h3 className="name-heading">Tori Cayle</h3>
				</div>

				<div className="profile-container">
					<div className="profile-left">
						<div className="profile-image-wrapper">
							<img
								src="/headshot.png"
								alt="Tori Cayle"
								className="profile-image"
							/>
						</div>
						<div className="profile-intro">
							<p>
								Once an individual is placed, she is acutely aware of the unique
								challenges siblings face, with a deep understanding of the
								hardships they may encounter during their loved one's
								therapeutic journey. Her goal is to bridge the gap between
								programs, families, and siblings, ensuring a holistic approach
								to support and guidance.
							</p>
							<p>
								Tori has found that making connections with programs that
								facilitate healing and unity within families is something she is
								deeply passionate about. Her love for connecting with others, in
								and outside of work, is a reflection of her genuine interest in
								people and culture. In her free time, she extends this passion
								in her personal life by spending time with friends and family.
								Tori's love for diverse cultures led her to spend a year
								teaching English to elementary school students in Bat Yam,
								Israel and she currently lives in Tel Aviv. In her free time,
								Tori loves to spend time at the beach, working out, and playing
								with her new puppy!
							</p>
						</div>
					</div>

					<div className="profile-section">
						<p className="intro-text">
							Tori's journey began when her little brother enrolled in Open Sky
							Wilderness Therapy.
						</p>

						<div className="timeline-section">
							<div className="timeline-entry right">
								<p>
									Seeking extra support, Tori's parents engaged with Three
									Treatment Consulting to assist with aftercare. As her brother
									faced and overcame the challenges of the wilderness, Tori
									noticed a lack of support for herself during the program.
								</p>
							</div>

							<div className="timeline-entry left">
								<p>
									Fortunately, Sarah McGuiness offered invaluable guidance
									throughout her brother's treatment, inspiring Tori's
									commitment to helping families through similar experiences.
								</p>
							</div>

							<div className="timeline-entry right right-up">
								<p>
									After earning a BS in Psychology at Colorado State University,
									Tori joined the Thrive team. She has spent over two years as
									an Intake and Placement Coordinator, working closely with
									programs to ensure clients within the Thrive family find the
									ideal placement for their loved ones.
								</p>
							</div>
						</div>
						<div className="timeline-image-wrapper">
							<img
								src="/images/about-p3.jpeg"
								alt="Winding bridge road"
								className="timeline-image"
							/>
						</div>
					</div>
				</div>
			</section>

			<section className="core-values-section">
				<h2 className="core-values-heading">Our Core Values</h2>

				<div className="core-values-container">
					{/* Personal Experience Card */}
					<div className="core-value-card">
						<div className="card-image">
							<img
								src="/images/about-p4.jpeg"
								alt="Two young siblings smiling"
							/>
						</div>
						<h3>Personal Experience</h3>
						<p>
							Tori Cayle's unique, first-hand experience as a sibling in
							therapeutic settings is unmatched. This personal journey provides
							invaluable insights and real-life scenarios, allowing us to
							develop effective strategies and solution tailored specifically
							for siblings facing similar challenges. Her expertise helps us
							create a supportive and inclusive environment where siblings feel
							understood, empowered, and equipped to navigate their own unique
							experiences.
						</p>
					</div>

					{/* Respect & Inclusivity Card */}
					<div className="core-value-card">
						<div className="card-image">
							<img
								src="/images/about-p5.jpeg"
								alt="Paper cutout figures holding hands"
							/>
						</div>
						<h3>Respect & Inclusivity</h3>
						<p>
							At Sibling Kinect, Tori Cayle upholds the highest standards of
							respect for all individuals and families. She honors and supports
							diverse identities, including gender, sexual orientation,
							ethnicity, age, cultural background, and religious beliefs. She
							strives to foster an environment where everyone feels valued and
							heard. Tori believes that mutual respect is essential for
							fostering positive relationships both within Sibling Kinect and in
							the home environment.
						</p>
					</div>

					{/* Bridging the Gap Card */}
					<div className="core-value-card">
						<div className="card-image">
							<img
								src="/images/about-p6.jpeg"
								alt="Suspension bridge in forest"
							/>
						</div>
						<h3>Bridging the Gap</h3>
						<p>
							Sibling Kinect's mission is to bridge the gap between siblings,
							families, and therapeutic processes to create a harmonious home
							environment. This involves navigating the complexities of family
							dynamics, resolving conflicts constructively, and fostering
							understanding through effective communication. We provide tools
							and strategies to help families work together towards a more
							cohesive and supportive unit.
						</p>
					</div>
				</div>
			</section>

			<section
				className="testimonials-section"
				style={{ backgroundImage: "url('/images/testimonials.jpeg')" }}
			>
				<h2 className="testimonials-heading">
					<span>What Our</span> Clients Say
				</h2>

				<div className="testimonials-container">
					<div className="testimonial-card">
						<div className="quote-content">
							<p>
								Working with Tori has been one of the best things I've done.
								Before working with Tori, I felt like no one truly understood
								what I was going through with my family. Tori was able to help
								me work through my emotions, let go of resentment, and work up
								the courage to set boundaries with my family. I would 100%
								recommend working with Tori!
							</p>
							<h3 className="testimonial-author">Emma Hartmayer</h3>
						</div>
					</div>
				</div>
			</section>

			<section className="kinect-section">
				<div
					style={{
						height: "300px",
						width: "80%",
						backgroundImage: "url('/images/services-home-bg.jpeg')",
						backgroundSize: "cover",
						backgroundPosition: "center",
						borderRadius: "10px",
					}}
				>
					<h1>Let’s bridge the gap and get kinected!</h1>
					<button className="cta-button" onClick={() => navigate("/contact")}>
						Contact Us
						<FontAwesomeIcon
							icon={faArrowRight}
							style={{ marginLeft: "10px" }}
						/>
					</button>
				</div>
			</section>
			<Footer />
		</div>
	);
}

export default About;
